// extracted by mini-css-extract-plugin
module.exports = {"container":"Hand_container__3DZ1g","isTakingBack":"Hand_isTakingBack__3xD8D","tile":"Hand_tile__qsdmL"};